/* globals $ */
import { registerClass } from 'libs/ComponentLoader'
import { PAGE_COMPONENTS_LOADED } from '_global/js/main'
import { TABLET_LANDSCAPE } from '_global/js/constants'
import { CLOSE_SEARCH } from 'components/SearchInput'

import { rcmShopifyApi, CART_CHANGED } from 'libs/rcmShopifyApi'

import './styles.scss'

class Header {
  constructor (element) {
    this.$el = $(element)

    this.searchInput = null
    this.isSearchMobile = false

    this.$searchButton = this.$el.find('.utilityMenu-searchButton')
    this.$searchDropdownWrapper = this.$el.find('.header-searchDropdownWrapper')
    this.$mobileSearchDropdownWrapper = this.$el.find('.header-mobileSearchDropdownWrapper')

    this.$searchButton.on('click', this.showSearch.bind(this))

    $(window).on('resize', this.checkSearchDropdown.bind(this))

    $(document).on(PAGE_COMPONENTS_LOADED, (e) => {
      this.searchInput = this.$el.find('.searchInput').data('component')
      this.searchInput.$el.on(CLOSE_SEARCH, this.closeSearch.bind(this))
      this.checkSearchDropdown()
    })

    rcmShopifyApi.on(CART_CHANGED, (responseData) => {
      const { cartData } = responseData
      const { item_count: count } = cartData

      this.updateCartCount(parseInt(count))
    })
  }

  updateCartCount (count) {
    const $cartCount = this.$el.find('.utilityMenu-cartCount')
    const countText = (count > 99) ? '99+' : count

    if (count > 0) {
      $cartCount.removeClass('u--hide')
    } else {
      $cartCount.addClass('u--hide')
    }
    $cartCount.find('.utilityMenu-cartAmount').html(countText)

    if (count === 1) {
      $cartCount.find('.icon__fallback-text').html('item')
    } else {
      $cartCount.find('.icon__fallback-text').html('items')
    }
  }

  showSearch () {
    this.checkSearchDropdown()

    this.$el.addClass('header-searchActive')
    this.searchInput.open()
  }

  closeSearch () {
    this.$el.removeClass('header-searchActive')
    this.$searchButton.focus().blur()
  }

  checkSearchDropdown () {
    const mqTabletLandscape = window.matchMedia(TABLET_LANDSCAPE)

    if (mqTabletLandscape.matches) {
      if (!this.isSearchMobile) {
        this.searchInput.$el.detach()
        this.$mobileSearchDropdownWrapper.append(this.searchInput.$el)
        this.isSearchMobile = true
      }
    } else {
      if (this.isSearchMobile) {
        this.searchInput.$el.detach()
        this.$searchDropdownWrapper.append(this.searchInput.$el)
        this.isSearchMobile = false
      }
    }
  }
}

registerClass('Header', Header)
